import axios, { AxiosResponse } from 'axios';
import { LoggedUser } from '../types/Usuario/LoggedUser';

const appID : string= process.env.REACT_APP_ID!

const SERV_BACK: string = process.env.REACT_APP_BACK || '';
const APIACCOUNT = '/api/account/';

export default class AccountService {

    static async Login(username: string): Promise<any> {
        const body = JSON.stringify({
            "idapp": appID,
            "netid": username
        });
        console.log(`${SERV_BACK}${APIACCOUNT}login`)
        const response1: AxiosResponse<any> = await axios.post(`${SERV_BACK}${APIACCOUNT}`,
            body,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        );
        return response1.data;
    }

}